import { ClerkProvider } from '@clerk/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Toaster } from 'sonner';
import { App } from './app.tsx';
import { ErrorBoundary } from './components/error-boundary.tsx';
import { queryClient } from './lib/query-client.ts';
import './styles/globals.css';

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root não encontrado');

// Aparência do Clerk — alinhada à marca Masterboi. O login é por redirect
// direto (sem modal), então só precisamos das variáveis de marca para a tela
// de callback e qualquer UI do Clerk.
const clerkAppearance = {
  variables: {
    colorPrimary: '#C8102E',
    borderRadius: '0.625rem',
    fontFamily: "'Gotham', 'Montserrat', system-ui, -apple-system, sans-serif",
  },
};

const tree = (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    <Toaster position="top-right" richColors />
  </QueryClientProvider>
);

// Com publishableKey → tudo dentro do ClerkProvider (gating de auth funciona).
// Sem a key (modo dev) → app sem gating.
const withAuth = publishableKey ? (
  <ClerkProvider
    publishableKey={publishableKey}
    afterSignOutUrl="/login"
    appearance={clerkAppearance}
  >
    {tree}
  </ClerkProvider>
) : (
  tree
);

// ErrorBoundary externo: último recurso contra tela branca. Fica por fora dos
// providers (Clerk, Query, Router), então pega até exceção de inicialização
// deles. O boundary por rota (app.tsx) é quem trata erro de tela.
createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary label="raiz">{withAuth}</ErrorBoundary>
  </StrictMode>,
);
